import { useState, useEffect } from 'react'

// Breakpoints from CLAUDE.md:
// Desktop:        1280px+
// Desktop narrow: 1024–1279px
// Tablet:         768–1023px
// Mobile:         <768px

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches)

  useEffect(() => {
    const mql = window.matchMedia(query)
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches)
    mql.addEventListener('change', handler)
    return () => mql.removeEventListener('change', handler)
  }, [query])

  return matches
}

export function useIsDesktop(): boolean {
  return useMediaQuery('(min-width: 1280px)')
}

export function useIsDesktopNarrow(): boolean {
  return useMediaQuery('(min-width: 1024px) and (max-width: 1279px)')
}

export function useIsTablet(): boolean {
  return useMediaQuery('(min-width: 768px) and (max-width: 1023px)')
}

export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 767px)')
}
